import axios from "../axiosPlugin.js"

export const getRevenueGoalList = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/report/salesGoalReport",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const saveRevenueGoal = (data, loading = true, isDefaultAlertTips = true) => {
  return axios({
    url: "/api/salesGoalTotal/create",
    method: "post",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};
